var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user && _vm.user.photo)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.user.photo.fullPath,"alt":"avatar"}}):_c('div',{staticClass:"avatar placeholder"},[_vm._v(_vm._s(_vm.initials))])}
var staticRenderFns = []

export { render, staticRenderFns }